import React from 'react';
import ProfileCard from './profile-card';
import type { ProfileCards as Props } from './profile-cards.types';

const ProfileCards: React.FunctionComponent<Props> = ({ profiles }) =>
  profiles.length ? (
    <div className="profile-cards__wrapper">
      {profiles.map(profile => (
        <ProfileCard {...profile} key={profile.url} />
      ))}
    </div>
  ) : null;

export default ProfileCards;
